export enum EndpointsCredentials {
  LoginCredentials = "/user/login"
}